import { jsx as C } from "react/jsx-runtime";
import { getStoreDefaultImage as c } from "../utils/get-store-default-image.mjs";
import { getStoreImageHeight as y, getStoreImageWidth as D } from "../utils/get-store-image-size.mjs";
import { useDesignContext as I } from "../providers/use-design-provider.mjs";
import { getColors as S } from "../themes/utils/color-utils.mjs";
import { defaultDesignValues as f } from "../themes/constants/default-design-values.mjs";
const G = ({
  src: e,
  imageType: o,
  alt: i,
  className: a,
  width: m = D(o),
  height: l = y(o),
  skipTheme: n
}) => {
  const { isDefaultTheme: u, state: g } = I(), { primaryColor: s, secondaryColor: p } = S(g), r = !e, t = r && !u && !n, d = r ? c(o, {
    width: m,
    height: l,
    fill: t ? s : "rgb(var(--text-primary))",
    className: a,
    primaryColor: t ? s : f.default.primaryColor,
    secondaryColor: t ? p : f.default.secondaryColor
  }) : null;
  return r ? d : /* @__PURE__ */ C("img", { className: a, alt: i, width: m, height: l, src: e });
};
export {
  G as default
};
